import { render, staticRenderFns } from "./CompactGallery.vue?vue&type=template&id=dfbfc892&"
import script from "./CompactGallery.vue?vue&type=script&lang=js&"
export * from "./CompactGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports